import * as React from 'react';
import { DataConnectionRowComponent, DataConnectionRowProps } from './DataConnectionRow';

const style: React.CSSProperties = {
  listStyleType: 'none',
  paddingLeft: 0
};

export interface DataConnectionListProps {
  dataConnections: DataConnectionRowProps[];
}

export function DataConnectionListComponent({ dataConnections }: DataConnectionListProps): React.ReactElement<DataConnectionListProps> {
  return (
    <ul style={style}>
      {dataConnections.map((dataSource, index) => <DataConnectionRowComponent key={index} {...dataSource} />)}
    </ul>
  );
}
